import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from 'react-router-dom';
import api from '../../utils/api'; // ✅ استخدام axios instance الجاهز
import CreateActivist from './CreateActivist';

const EditActivist = (props) => {
    const { id } = useParams();
    const [activist, setActivist] = useState(null); // ✅ توحيد الاسم
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        props.setBreadcrumbItems('تعديل ناشط', [
            { title: "الرئيسية", link: "/dashboard" },
            { title: "الناشطين", link: "/dashboard/activists" },
            { title: "تعديل ناشط", link: "#" }
        ]);
        fetchActivist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchActivist = async () => {
        try {
            const response = await api.get(`/activists/${id}`); // ✅ بفضل instance

            if (response.data && response.data.data) {
                setActivist(response.data.data);
            } else {
                
                setActivist(null);
            }
        } catch (error) {
            
            setActivist(null);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>جاري تحميل بيانات الناشط...</p>;
    if (!activist) return <p>لم يتم العثور على الناشط.</p>;

    return (
        <CreateActivist mode="edit" activistData={activist} />
    );
};

export default connect(null, { setBreadcrumbItems })(EditActivist);
